import { render, staticRenderFns } from "./salonListesi.vue?vue&type=template&id=b63fb130&scoped=true&"
import script from "./salonListesi.vue?vue&type=script&lang=js&"
export * from "./salonListesi.vue?vue&type=script&lang=js&"
import style0 from "./salonListesi.vue?vue&type=style&index=0&id=b63fb130&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63fb130",
  null
  
)

export default component.exports